// Exports all module elements
import reducerCMS from './reducers';

// export { default constantsCMS } from './constants';
export { default as typeCMS } from './types';
export { default as sagasCMS } from './sagas';

export default reducerCMS;
